import "@/App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { Marquee } from "./components/Marquee";
import { ProceduresSection } from "./components/ProceduresSection";
import { AboutSection } from "./components/AboutSection";
import { LeadForm } from "./components/LeadForm";
import { FAQSection } from "./components/FAQSection";
import { LocationSection } from "./components/LocationSection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <Marquee />
        <ProceduresSection />
        <AboutSection />
        <LeadForm />
        <FAQSection />
        <LocationSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
